<template>
  <div class="mt-8">
    <v-data-table
      class="data__table"
      ref="table"
      :headers="headers"
      :items="parkingsList"
      fixed-header
      hide-default-footer
      disable-pagination
      :no-data-text="noDataText || $vuetify.lang.t('$vuetify.noDataText')"
      :mobile-breakpoint="mobileBreakpoint"
    >
      <template v-slot:item.car_registration_number="{ item }">
        <span translate="no">{{ item.car_registration_number }}</span>
      </template>
      <template v-slot:item.start_time="{ item }">
        {{ moment(item.start_time).format('DD.MM.YY HH:mm') }}
      </template>
      <template v-slot:item.end_time="{ item }">
        {{ moment(item.end_time).format('DD.MM.YY HH:mm') }}
      </template>
      <template v-slot:item.revenue="{ item }">
        {{ roundToTwoSigns(item.revenue) }}
      </template>
      <template v-slot:item.without_vat="{ item }">
        {{ roundToTwoSigns(item.without_vat) }}
      </template>
    </v-data-table>
    <div
      v-if="loadMoreLicencePlatesBtnState"
      ref="scrollSentinel"
      class="scroll-sentinel"
    />
  </div>
</template>

<script>
import auth from '@/auth'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'LicencePlateSearchTable',
  props: {
    parkingsList: {
      type: Array,
      default: () => []
    },
    noDataText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      auth: auth,
      moment: moment,
      observer: null,
      headers: [
        { text: this.$t('location'), value: 'location.name' },
        { text: this.$t('licence_plate'), value: 'car_registration_number' },
        { text: this.$t('start_time'), value: 'start_time' },
        { text: this.$t('stop_time'), value: 'end_time' },
        { text: this.$t('discount'), value: 'discount' },
        { text: this.$t('revenue'), value: 'revenue' },
        { text: this.$t('excl_VAT'), value: 'without_vat' }
      ],
      mobileBreakpoint: 767
    }
  },
  computed: {
    ...mapGetters(['loadMoreLicencePlatesBtnState']),
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint
    }
  },
  watch: {
    loadMoreLicencePlatesBtnState() {
      this.$nextTick(() => this.setupObserver())
    }
  },
  mounted() {
    this.setupObserver()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    setupObserver() {
      if (this.observer) {
        this.observer.disconnect()
      }
      const sentinel = this.$refs.scrollSentinel
      if (!sentinel) return
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this.$emit('loadMore')
          }
        },
        { threshold: 0 }
      )
      this.observer.observe(sentinel)
    },
    roundToTwoSigns(num) {
      return num ? num.toFixed(2) : ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/common';

.scroll-sentinel {
  height: 1px;
}
</style>
